import styled from 'styled-components';

export const ToggleWrapper = styled.div`

`;

export const ToggleLabel = styled.label`
  display: inline-block;
  height: 22px;
  position: relative;
  width: 44px;
`;

export const ToggleInput = styled.input`
  display: none;
  
  &:checked + div {
    background-color: ${props => props.theme.colors.selectedColor};
    &:before {
      transform: translateX(22px);
    };
  };
`;

export const ToggleInner = styled.div`
  background-color: ${props => props.theme.colors.gray};
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: .4s;
  border-radius: 34px;
    
  &:before{
    background-color: ${props => props.theme.colors.white};
    bottom: 3px;
    content: "";
    height: 16px;
    left: 3px;
    position: absolute;
    transition: .4s;
    width: 16px;
    border-radius: 50%;
  };
`;



// WEBPACK FOOTER //
// ./src/components/shared/ToggleButton/styles.js